document.addEventListener('DOMContentLoaded', () => {
	const qaPairs = document.querySelectorAll('.qa-pair')

	qaPairs.forEach(pair => {
		let answer = pair.querySelector('.answer')
		pair.setAttribute('style', `--height: ${answer.scrollHeight}px;`)

		pair.addEventListener('click', e => {
			pair.classList.toggle('active')

			if (pair.classList.contains('active')) {
				pair.classList.remove('inactive')
			} else {
				pair.classList.add('inactive')
			}
		})

		window.addEventListener('resize', () => {
			pair.setAttribute('style', `--height: ${answer.scrollHeight}px;`)
		})
	})
})
